<template>
    <div class="cut_box">
        <div class="mask"></div>
        <div class="levelup">
            <span class="bg">
            </span>

            <div class="text"> 集八宝<br />赢奖品!</div>
            <span class="btn" @click="handleClose"></span>
        </div>
    </div>
</template>

<script>

export default {
    props: ['onCancel', "musicCol"],

    data() {
        return {}
    },
    methods: {
        handleClose() {
            this.musicCol(true);
            this.onCancel()
        }
    }
}
</script>

<style lang="less" scoped>
.cut_box {
  position: absolute;
  width: 7.5rem;
  height: 16.24rem;
  left: 0;
  top: 0;

  .mask {
    background-color: rgb(0, 0, 0);
    width: 100%;
    height: 100%;
    opacity: 0.8;
  }

  .levelup {
    width: 7.5rem;
    height: 5.94rem;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -50%);
    position: absolute;

    .bg {
        width: 7.5rem;
      height: 5.94rem;
      left: 0rem;
      top: 0rem;
      position: absolute;
      background: url("https://yun.duiba.com.cn/polaris/bg.0319e081c58d16cc8dd95f0fd71c16fb20fd4afa.png") no-repeat top left / 100% 100%;


    }

    .btn {
      width: 2.38rem;
      height: 0.73rem;
      left: 50%;
      transform: translate(-50%,0);
      top: 3.91rem;
      position: absolute;
      background: url("https://yun.duiba.com.cn/polaris/btn.baff6cee16ef4af4a7521029a5babf79fc2c1594.png") no-repeat top left / 100% 100%;

    }

    .text {
      width: 100%;
      text-align: center;
      position: absolute;
      top: 2.05rem;
      font-size: 0.47rem;
      color: rgb(165, 96, 73)
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/openMusic/index.vue